var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InstallmentSimulationModal',{attrs:{"base-price":_vm.basePrice,"name":_vm.name,"payment-group-id":_vm.PAYMENT_GROUPS.ONEY,"payment-methods":_vm.paymentMethods},scopedSlots:_vm._u([{key:"trigger",fn:function(ref){
var open = ref.open;
return [_vm._t("trigger",null,null,{ open: open })]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }